<template>
    <div class="geo_barangay_block">        
        <!-- <pre>{{ GeoBarangays }}</pre> -->
        <!-- {{ backendPrefix }} -->
        <div v-if="(GeoBarangays.length>0)" class="label_tree">
            <div class="flex items-center gap-2 geo_label">
                <i v-if="barangay_tree_on" class="fa fa-minus" @click="tree_on_status(false)"></i>
                <i v-else class="fa fa-plus" @click="tree_on_status(true)"></i>
                <span>Barangay</span>
            </div>
            <div :class="['geo_tree',{active:barangay_tree_on}]">
                <div v-for="barangay in GeoBarangays">
                    <div :class="['flex','items-center','gap-2','input_block',{active:sel_barangays && sel_barangays[barangay.id]}]" @click="sel_barangay(barangay.id)">
                        <span class="square_block">
                            <i class="fa fa-check check"></i>
                            <i class="fa fa-times remove"></i>
                        </span>
                        <div>{{ barangay.barangay_name }}</div>
                    </div>
                </div>                
            </div>   
        </div>        
        <div v-else class="geo_tree active">
            <div class="flex items-center gap-2 input_block">
                <span class="square_block" @click="load_data">                    
                    <i v-if="preloader" class="fa fa-cog fa-spin show"></i>
                    <i v-else class="fa fa-plus show"></i>
                </span>
                <span v-if="preloader">Barangay Loading...wait</span>                
            </div>
        </div>        
    </div>
</template>
<script>
    import axios from "axios"
    import { ref, toRefs, onMounted } from 'vue'
    export default {
        name: "GeoBarangayBlock",
        props: {
            municipality_id: Number,
            sel_barangays: Object
        },
        setup(props, { emit }) {
            const { municipality_id, sel_barangays } = toRefs(props)
            const backendPrefix = ref(process.env.MIX_ADMIN_PREFIX)
            const preloader = ref(false)
            const GeoBarangays = ref([])
            const barangay_tree_on = ref(true)

            onMounted( () => {
                barangay_tree_on.value = true
                load_data()
            })

            const tree_on_status = (status) => {
                barangay_tree_on.value = status
            }

            const sel_barangay = (barangay_id) => {
                // //console.log('barangay', barangay_id)
                emit('selBarangay', barangay_id)
            }

            const load_data = () => {
                let formData = {
                    geo_municipality_id: municipality_id.value
                }
                preloader.value = true
                axios.post(`/${backendPrefix.value}/barangays/activebarangays`, formData).then( async (response) => {
                    //console.log(response)                   
                    GeoBarangays.value = response.data
                    preloader.value = false
                }).catch(error => {
                    preloader.value = false
                    //console.log(error.response.data.error)
                })
            }

            return {
                backendPrefix,
                municipality_id,
                preloader,
                GeoBarangays,
                sel_barangays,
                barangay_tree_on,
                load_data,
                sel_barangay,
                tree_on_status
            }
        }
    }
</script>
<style lang="scss" scoped>
    $tree_layer_gap_x: 18;
    $tree_layer_gap_y: 16;
    .input_block{
        position: relative;
        height: 30px;
        cursor: pointer;

        & > .square_block{
            display: flex;
            align-items: center;
            justify-content: center;            
            width: 20px; height: 20px;
            border: 1px solid #999;
            border-radius: 5px;

            & > i{
                display: none;
                font-size: 10px;
                
                &.show{
                    display: block;
                }
            }
        }

        &:hover{
            font-weight: 600;
            .square_block{
                & > i.check {
                    display: block;
                }
            }
        }

        &.active{
            color: #006699;
            font-weight: 600;
            .square_block{
                border-color: #006699;
                & > i.check{
                    display: block;
                    color: #006699
                }
            }
            &:hover{
                color: #CD0000;                    
                .square_block{
                    border-color: #CD0000;
                    & > i.check{
                        display: none;
                    }
                    & > i.remove{
                        display: block;
                        color: #CD0000
                    }
                }
            }
        }
    }

    .label_tree{
        position: relative;
        padding-left: #{$tree_layer_gap_x}px;
        margin-left: 10px;
        .geo_label{
            font-size: 14px;
            font-weight: 600;            
            height: 34px;

            &::before{
                position: absolute;
                content: "";
                width: 20px;
                height: 24px;
                border-bottom: 1px solid #999;
                border-left: 1px solid #999;
                border-radius: 0 0 0 5px;
                left: 0px;
                top: -5px;
            }

            & > i{
                position: relative;
                left: 0;
                width: 22px;
                height: 22px;
                border: 1px solid #999;
                background-color: #fff;
                border-radius: 5px;
                line-height: 22px;
                text-align: center;
                font-size: 10px;
                color: #666;
                cursor: pointer;
                z-index: 1;
            }
        }        
    }
    .geo_tree{
        position: relative;
        display: none;
        margin-left: 10px;
        transition: all 0.4s;
        &.active{
            display: block;
        }
        &::before{
            position: absolute;
            content: "";
            width: 5px;
            height: calc(100% - 8px);
            border-left: 1px solid #999;
            border-bottom: 1px solid #999;
            border-radius: 0 0 0 5px;
            left: 0;
            top: -6px;
        }
        & > div{
            position: relative;
            padding-left: #{$tree_layer_gap_x}px;

            &::before{
                position: absolute;
                content: "";
                width: #{$tree_layer_gap_x}px;
                height: #{$tree_layer_gap_y}px;
                border-bottom: 1px solid #999;
                border-left: 1px solid #999;
                border-radius: 0 0 0 5px;
                left: 0;
                top: 0;
            }            
        }
    }
</style>